export * from './data.actions';


// WEBPACK FOOTER //
// src/store/actions/medprocure/index.js